import React from 'react';

const Home = () => {
  return (
    <div className="bg-gray-50 min-h-screen flex flex-col items-center justify-center">
      <h1 className="text-4xl font-bold text-blue-600"> Bienvenue sur lii</h1>
      <p className="text-gray-600 mt-4 text-center max-w-md">
       Le réseau social privé dédié exclusivement aux familles 🏡
      </p>
      <div className="mt-6 flex space-x-4">
        <a
          href="/signup"
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700"
        >
          S'inscrire
        </a>
        <a
          href="/login"
          className="border border-blue-600 text-blue-600 px-6 py-2 rounded hover:bg-blue-100"
        >
Se connecter        </a>
      </div>
    </div>
  );
};

export default Home;